import { render, staticRenderFns } from "./shuffle.vue?vue&type=template&id=16cf1d62"
import script from "./shuffle.vue?vue&type=script&lang=js"
export * from "./shuffle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports